import { useState } from 'react';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';

import { getSharedProperty } from '../../../getters';
import {
  PopularSearches,
  QuickLinksContent,
  SitecoreDictionaryItem,
  SitecoreItem,
} from '../../../types';
import { useComponentProps } from '../../../utils/hooks/useComponentFields';
import { SearchMenuInput } from './SearchMenuInput';

export const MobileSearchMenu = () => {
  const componentProps: ComponentRendering | null = useComponentProps('Search');
  const menuItem = componentProps?.fields;

  const popularSearchesFields = menuItem as unknown as {
    SearchTextPlaceholderShared: SitecoreDictionaryItem;
    PopularSearchesShared: SitecoreItem<PopularSearches>;
    QuickLinksShared: SitecoreItem<QuickLinksContent>;
  };

  const inputPlaceholderText = getSharedProperty(
    popularSearchesFields.SearchTextPlaceholderShared.fields,
    'Phrase'
  );

  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="flex w-full bg-gray-50 px-5 pb-10 pt-3">
      <SearchMenuInput
        showSearchButton={true}
        inputPlaceholderText={inputPlaceholderText?.value || ''}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        autofocus={false}
      />
    </div>
  );
};
